import { AuthService } from "@teaming/io-auth";
import config from "../config";
import compact from "lodash/compact";

const NEW_REPO_PATHS = [
	"onboarding",
	"signup",
	"signin",
	"one-on-ones",
	"one-on-one",
	"teams",
	"team",
	"loading",
];
let instance;

function getRedirectRoute( { to, } ) {
	let redirect = to.fullPath;
	const [ firstPath, ] = compact( redirect.split( "/" ) );
	if ( NEW_REPO_PATHS.includes( firstPath ) ) {
		redirect = `/t2${ redirect }`;
	}
	return redirect;
}

/**
 * This is our singleton getter for the auth service
 * within the "host" app. The MAX_LISTENERS value was
 * necessary in the old reports repo - but we need to
 * determine if it's still necessary and, if so, *why*
 */
export function getAuthServiceInstance() {
	if ( instance ) {
		return instance;
	}

	instance = new AuthService( config );

	instance.authGuard = async ( to, from, next ) => {
		try {
			if ( !await instance.isAuthenticated() ) {
				await instance.renewTokens();
			}
			const auth0User = await instance.lookupUser();
			if ( !auth0User.email_verified ) {
				return next( {
					path: "/verify-email",
				} );
			}
			return next();
		} catch ( e ) {
			return next( {
				path: "/signin",
				query: { redirect: getRedirectRoute( { to, } ), },
			} );
		}
	};

	instance.softGuard = async ( to, from, next ) => {
		try {
			if ( !await instance.isAuthenticated() ) {
				await instance.renewTokens();
			}
			return next();
		} catch ( e ) {
			return next( {
				path: "/signin",
				query: { redirect: getRedirectRoute( { to, } ), },
			} );
		}
	};

	return instance;
}
